import AppConfig from "@/_config/application-config"
import childRoutes from "@/apps/long-lead/routes/index.js"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const namespace = "longlead"
const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Long Lead",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-alpha-r-circle-outline",
  parentRoute: "/long-lead",
  accentColor: "red",
  childRoutes,
  defaultRoute: "executivesummary",
  // domainName : "alignedautomation.com",
  domainName : "lyondellbasell.com",
  component: () => import("@/apps/long-lead/Application.vue"),
  settings: {
    // baseUrl : "https://as-gputallmvapi-uat.azurewebsites.net/api/", // UAT
    baseUrl : "https://as-gputallmvapi-dev.azurewebsites.net/api/", 
    client_id: "f8144895-f0bf-453a-b1af-56aabc299746",
    scope:"api://f8144895-f0bf-453a-b1af-56aabc299746/f8144895-f0bf-453a-b1af-56aabc299746",
    authorizeUrl:
      "https://login.microsoftonline.com/3dcd35b5-f9c5-48ca-8653-821568ad3397/oauth2/v2.0/authorize",
    tokenUrl:
      "https://login.microsoftonline.com/3dcd35b5-f9c5-48ca-8653-821568ad3397/oauth2/v2.0/token",
    logoutUrl:
      "https://login.microsoftonline.com/3dcd35b5-f9c5-48ca-8653-821568ad3397/oauth2/v2.0/logout?",
    redirect_uri: window.location.origin, //Gets the current
    autologin: true,
    debug: false,
    currentTime: null,
    currentTimeInterval: null,
    azure_deployed: 1,
    navigation: [
      {
        icon: "mdi-view-quilt",
        text: "TA Executive Summary",
        link: "/long-lead/executivesummary",
        roles: ["SuperAdmin","Admin","User"],
      },
      {
        icon: "mdi-file-document-multiple",
        text: "Summary ",
        link: "/long-lead/summary",
        roles: ["SuperAdmin","Admin","User"],
      },
      {
        icon: "mdi-floor-plan",
        text: "Material Visibility",
        link: "/long-lead/materialVisibility",
        roles: ["SuperAdmin","Admin","User"],
      },
      {
        icon: "mdi-view-grid",
        text: "Expediting Report",
        link: "/long-lead/ExpeditingReport",
      },
      {
        icon: "mdi-monitor-dashboard",
        text: "Material Planning",
        link: "/long-lead/planning"
      },
      {
        icon: "mdi-file-table-box-outline",
        text: "Project Sourcing Schedule",
        link: "/long-lead/projectSourcingSchedule", // old Name is Gewerke
        roles: ["SuperAdmin","Admin","User"],
      },
      {
        icon: "mdi-chart-box-outline",
        text: "LL Visibility Report",
        link: "/long-lead/llvisibilityreport",
        roles: ["SuperAdmin","Admin","User"],
      },
      {
        icon: "mdi-file-cog-outline",
        text: "Milestone Master Summary",
        link: "/long-lead/milestoneMasterSummary",
        roles: ["SuperAdmin","Admin"],
      },
      {
        icon: "mdi-application-cog",
        text: "Admin",
        link: "/long-lead/admin",
        roles: ["SuperAdmin","Admin"],
        items: [
          {
            icon: "mdi-account-multiple",
            text: "Users",
            link: "/long-lead/users",
          },
          
          {
            icon: "mdi-table-cog",
            text: "Material Applicability",
            link: "/long-lead/materialapplicability",
          },
          {
            icon: "mdi-file-document-plus-outline",
            text: "TAWBS Mapping ",
            link: "/long-lead/tawbSmapping",
          },
          {
            icon: "mdi-file-document-plus-outline",
            text: "Categories and Segments",
            link: "/long-lead/managecategoriessegments",
          },
        ]
      }
    ],
  },
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    themeColor : {
      default: "red",
      storageMode : localStorage,
    },
    isTrue : {
      default: true,
      storageMode : sessionStorage,
    },
  }

}

export default AppConfig.merge(appConfig);


